<template>
    <vx-modal v-model:visible="visible" size="sm" :padding="false">
        <template v-slot:header>
            <div class="vx-pt-6 vx-px-6">{{ team.status === 'pending' ? 'Activate' : 'Re-Activate' }} Team</div>
        </template>
        <template v-slot:subheader>
            <div class="vx-px-6">
                {{ team.name }}
            </div>
        </template>

        <div v-if="team.status === 'suspended'" class="vx-p-8 vx-text-sm vx-text-slate-800">
            <div class="vx-mb-2">
                <strong>Are you sure you want to proceed?</strong> If you continue the following will happen:
            </div>
            <ul class="vx-list-disc vx-flex vx-flex-col vx-gap-1 vx-pl-6">
                <li>All current Owners and Members will recover their respective roles privileges.</li>
                <li>All automated messaging capabilities will be resumed.</li>
                <li>
                    <strong>Notice:</strong> Messages scheduled to be sent during the suspended period are already
                    discarded
                </li>
            </ul>
        </div>
        <div v-else class="vx-p-6">
            <vx-alert :closeable="false">Are you sure you want to proceed?</vx-alert>
        </div>

        <template v-slot:footer>
            <div class="vx-flex vx-flex-col-reverse vx-gap-4 lg:vx-flex-row">
                <vx-button
                    @click="visible = false"
                    type="button"
                    class="vx-grow lg:vx-w-20 lg:vx-grow-0"
                    size="lg"
                    color="muted"
                >
                    Cancel
                </vx-button>
                <vx-button
                    @click="confirm()"
                    data-test="confirm-activation"
                    :loading="activating"
                    type="button"
                    class="vx-grow"
                    size="lg"
                    color="primary"
                >
                    Confirm
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxButton, VxModal, VxAlert } from '@voxie/frontend-components';
import { ref } from 'vue';
import { HTTP_INTERNAL_SERVER_ERROR } from '~/support/HttpStatuses';
import { useToasted } from '~/composables/useToasted';
import adminTeamsClient from '~/services/adminTeamsClient';

const toasted = useToasted();

const visible = defineModel('visible', {
    type: Boolean,
    default: false,
});

const team = defineModel('team', {
    type: Object,
    required: true,
});

const activating = ref(false);

const confirm = async () => {
    if (activating.value) {
        return;
    }

    try {
        activating.value = true;

        await adminTeamsClient.activateTeam(team.value.id);

        visible.value = false;
        team.value.status = 'active';
        team.value.status_reason = '';
    } catch (e) {
        console.error(e);
        if (e?.response?.status >= HTTP_INTERNAL_SERVER_ERROR) {
            toasted.global.platform_error();
            return;
        }

        toasted.error(e.response?.data?.message || 'Something went wrong.');
    } finally {
        activating.value = false;
    }
};
</script>
